import React from 'react';

export const MenuContext = React.createContext(null);
